import gql from 'graphql-tag';

export const queryUsersByCompanyIdIndex = gql`
	query QueryUsersByCompanyIdIndex(
		$companyId: ID!
		$first: Int
		$after: String
	) {
		queryContactsByCompanyIdIndex(
			companyId: $companyId
			first: $first
			after: $after
		) {
			items {
				id
				firstName
				lastName
				emailAddress
				userId
				companyId
				phoneNumber
				importMethod
				dateCreated
			}
			nextToken
		}
	}
`;
